

import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class CatalogueService {

  constructor(private api: ApiService) { }


  getStatesList(value: string) {
    return this.api.getCatalogue('catalogue/statelist/')
      .then(result => result);
  }

  getStatesCivilList(value: string) {
    return this.api.getCatalogue('catalogue/estadoCivil/')
      .then(result => result);
  }

  getSubStatesCivil(value: string) {
    return this.api.getCatalogue('catalogue/subEstadoCivil/' + value)
      .then(result => result);
  }

  getStates(value: string) {
    return this.api.getCatalogue('catalogue/state/' + value)
      .then(result => result);
  }
  getMuni(value: string, cp: string) {
    return this.api.getCatalogue('catalogue/municipality/' + cp + '/' + value)
      .then(result => result);
  }
  getColony(value: string) {
    return this.api.getCatalogue('catalogue/colony/' + value)
      .then(result => result);
  }

  getTipoComercio() {
    return this.api.getCatalogue('catalogue/tipocomercio/')
      .then(result => result);
  }

  getOperacion() {
    return this.api.getCatalogue('catalogue/tiempooperacion/')
      .then(result => result);
  }

  getTipoPersona() {
    return this.api.getCatalogue('catalogue/tipopersona/')
      .then(result => result);
  }

  getAdquirentes() {
    return this.api.getCatalogue('catalogue/adquirente/')
      .then(result => result);
  }

  getBancos() {
    return this.api.getCatalogue('catalogue/bancos/')
      .then(result => result);
  }

  getTiempoOperacion() {
    return this.api.getCatalogue('catalogue/tiempooperacion/')
      .then(result => result);
  }

  getCotizadorFactor() {
    return this.api.getCatalogue('catalogue/cotizadorFactor/')
      .then(result => result);
  }



  getByPostalCode(value: string){
    return this.api.getCatalogue('address/getbypostalcode/' + value).then(result => result);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/service/core/cataloque.service.ts